<template>
  <form-section
    id="distributor_rights_and_obligations"
    :headline="this.$t('form.distributor_rights_and_obligations.legend')"
  >
    <checkbox
      id="shouldParticipate"
      v-model="distributorRightsAndObligations.shouldParticipate"
      :label="this.$t('form.distributor_rights_and_obligations.should_participate_in_fairs.label')"
    />

    <textfield
      v-if="distributorRightsAndObligations.shouldParticipate"
      id="number_of_fairs"
      :label="$t('form.distributor_rights_and_obligations.number_of_fairs.label')"
      :placeholder="$t('form.distributor_rights_and_obligations.number_of_fairs.placeholder')"
      v-model="distributorRightsAndObligations.numberOfFairs"
      isRequired
    />

    <textfield
      id="marketing_percent"
      :label="$t('form.distributor_rights_and_obligations.marketing_percent.label')"
      :placeholder="$t('form.distributor_rights_and_obligations.marketing_percent.placeholder')"
      v-model="distributorRightsAndObligations.marketingPercent"
      isRequired
      append-text="%"
    />
  </form-section>
</template>

<script>
import Checkbox from "@/shared/components/Checkbox.vue";
import Textfield from "@/shared/components/Textfield.vue";
import FormSection from "@/shared/components/FormSection.vue";
export default {
  components: {
    Checkbox,
    Textfield,
    FormSection
  },
  data() {
    return {
      distributorRightsAndObligations: {
        shouldParticipate: false,
        numberOfFairs: "",
        marketingPercent: ""
      }
    };
  },
  watch: {
    distributorRightsAndObligations: {
      handler() {
        this.$store.commit(
          "updateDistributorRightsAndObligations",
          this.distributorRightsAndObligations
        );
      },
      deep: true
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/apps/eneforhandler/components/form/DistributorRightsAndObligationsInput.vue